export default __webpack_public_path__ + "static/media/showroom39.2bc55f3d.webp";